import { CurrencyAPIPromiseClient } from "../../../gen/witbooking/backoffice/currency/v1/currency_api_grpc_web_pb";
import {
  Currency,
  GetCurrenciesRequest,
  GetCurrencyRequest,
  UpdateCurrencyRequest,
} from "../../../gen/witbooking/backoffice/currency/v1/currency_api_pb";
import { addAuthzMetadataGrpcCall, buildGrpcClient } from "../../../lib/grpc";
import { CurrencyEntity } from "../domain/currency.entity";

const grpcClient: CurrencyAPIPromiseClient = buildGrpcClient(CurrencyAPIPromiseClient);

function dtoFromEntity(obj: CurrencyEntity): Currency {
  const result = new Currency();
  result.setId(obj.id);
  result.setName(obj.name);
  result.setCode(obj.code);
  result.setPrimary(obj.primary);
  result.setVisible(obj.visible);
  return result;
}
export async function getAllEntities(): Promise<CurrencyEntity[]> {
  const request = new GetCurrenciesRequest();
  const getCurrencies = addAuthzMetadataGrpcCall(grpcClient, grpcClient.getCurrencies);
  const response = await getCurrencies(request);
  return response.getCurrenciesList().map(m => m.toObject());
}

export async function getEntity(id: string): Promise<CurrencyEntity> {
  const request = new GetCurrencyRequest();
  request.setId(id);
  const getCurrency = addAuthzMetadataGrpcCall(grpcClient, grpcClient.getCurrency);
  const response = await getCurrency(request);
  const entity = response.getCurrency();
  if (!entity) {
    throw new Error("Unexpected reply obtaining language");
  }
  return entity.toObject();
}

export async function updateEntity(entity: CurrencyEntity): Promise<void> {
  const request = new UpdateCurrencyRequest();
  request.setCurrency(dtoFromEntity(entity));
  const updateCurrency = addAuthzMetadataGrpcCall(grpcClient, grpcClient.updateCurrency);
  await updateCurrency(request);
}
